export default __webpack_public_path__ + "static/media/shopee2.52b45e10.png";